import type { Game } from '@sportybot-web/services/stats-api/types';

import { Button, Center, Loader, Stack, Title } from '@mantine/core';
import { GameClipsPage } from '@sportybot-web/features/game-view/components/game-clips-page';
import { getGameQueryOptions } from '@sportybot-web/services/stats-api/queries';
import { isToday } from '@sportybot-web/utils/date';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { RefreshCwIcon } from 'lucide-react';

export const Route = createFileRoute('/_authenticated/game-view/game-clips')({
  component: RouteComponent,
});

function RouteComponent() {
  const { date, gamePk, sportId } = Route.useSearch();

  const today = isToday(date);
  const { data, refetch, status } = useQuery({
    ...getGameQueryOptions(gamePk),
    refetchInterval: today ? 15_000 : false,
    select: ({ dates }): Game | undefined => dates[0]?.games[0] ?? undefined,
    staleTime: 0,
  });

  if (status === 'pending') {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  if (status === 'error' || !data) {
    return (
      <Center>
        <Stack align="center">
          <Title variant="heading-1">Failed to Fetch Game</Title>
          <Button onClick={() => refetch()} rightSection={<RefreshCwIcon size={16} />}>
            Retry
          </Button>
        </Stack>
      </Center>
    );
  }

  return <GameClipsPage game={data} key={gamePk} sportId={sportId} />;
}
